import { DefaultHeader } from "../headers/DefaultHeader";
import { SlideshowHeader } from "../headers/SlideshowHeader";
import { GradientHeader } from "../headers/GradientHeader";
import { IconHeader } from "../headers/IconHeader";
import { HeaderTemplate } from "../types";

export const getHeaderTemplate = (templateName: HeaderTemplate) => {
  switch (templateName) {
    case HeaderTemplate.Slideshow:
      return SlideshowHeader;
    case HeaderTemplate.Gradient:
      return GradientHeader;
    case HeaderTemplate.Icon:
      return IconHeader;
    case HeaderTemplate.Default:
    default:
      return DefaultHeader;
  }
};
